import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * StaleBanner — degraded mode is a NORMAL state, not downtime
 * (ORDER_DESK_DESIGN.md rule 5, generalised per docs/UI_STANDARDS.md §2.6).
 *
 * When an upstream system is unreachable, the screen serves last-known-good data,
 * says so plainly with the timestamp, and the caller disables every mutation.
 * Reads degrade; writes fail fast and are never queued.
 *
 * Props
 * - source: upstream system name, e.g. "Zoho"
 * - fetchedAt: raw timestamp from the API (formatted by `formatTimestamp`)
 * - formatTimestamp: (value) => string — caller supplies its own formatter
 */
const StaleBanner = ({
    source = 'Upstream',
    fetchedAt,
    formatTimestamp = (value) => value,
    sx = {},
}) => (
    <Alert
        severity="warning"
        icon={<WarningAmberIcon />}
        sx={{ mb: 2, borderRadius: 2, alignItems: 'center', fontWeight: 500, ...sx }}
    >
        <AlertTitle sx={{ fontWeight: 700, mb: 0.25 }}>
            {source} unreachable — showing last-known-good data
        </AlertTitle>
        Data as of {fetchedAt ? formatTimestamp(fetchedAt) : 'an unknown time'}. Actions are disabled
        until {source} is reachable again.
    </Alert>
);

export default StaleBanner;
